import React from "react";
import { useVerifyUserNameContainer } from "./UsernameContainer";
import Modal from "react-modal";
import { withRouter } from "react-router-dom";
import Input from "../../TravellerContactInfo/FormFields/Input";
import "../LoginModals.css";
import { UserFlowModalState } from "../../UserFlow/UserFlowModal";
import { customStyles } from "../../UserFlow/UserFlowModal";
import { SUBMIT } from "./Constants";

const VerifyIrctcUserName = (props: UserFlowModalState) => {
  const {
    props: {
      userStatus,
      showModal,
      state,
      irctcUserId,
      error,
      isChecked,
      isVerifiedId
    },

    action: {
      saveClose,
      handleCheck,
      checkIRCTCid,
      rotateLoader,
      closeModal,
      closeModalAction,
      goToIRCTCRegistrationPage,
      goToForgotUsernamePage,
      goToForgotPassWordPage,
      handleInputKeyUpViaParent
    }
  } = useVerifyUserNameContainer(props);

  const { disabled, rotate } = state;
  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className={"loginModals loginModals--v3"}
      id="mmt-irctc-modal"
      style={{
        overlay: {
          backgroundColor: "rgb(0, 0, 0, 0.6)",
          zIndex: 1
        },
        customStyles
      }}
    >
      <>
        <p className="makeFlex spaceBetween appendBottom10">
          <span className="modalTitle font26 latoBlack blackText">
            Enter IRCTC Username
          </span>
          <span
            className="modalClose railSprite crossIcon"
            onClick={closeModal}
          ></span>
        </p>
        <p className="additionalInfo appendBottom20 font14">
          IRCTC username{" "}
          <span className="blackText">will be required after Payment</span>.
          Please ensure you have entered correct username.
        </p>
        <div className={"makeFlex spaceBetween hrtlCenter"}>
          <Input
            labelName="Enter IRCTC Username"
            errorMessage={
              userStatus && userStatus.error
                ? userStatus.error ||
                  "No special characters allowed other than '_'"
                : ""
            }
            validationFail={error}
            type="text"
            additionalAttributes={{ placeholder: "sham171993" }}
            fieldId="IRCTCUserName"
            fieldName="IRCTCUserName"
            vaidationMsg=""
            vaidationMoreMsg={null}
            vaidationMoreStatus={false}
            vaidationStatus={true}
            readOnly={false}
            value={irctcUserId}
            style={"darkGreyText capText labelName greyed"}
            handleInputKeyUpViaParent={handleInputKeyUpViaParent}
          />
          <div>
            <button
              onClick={rotateLoader}
              className={`${disabled ? "disabled" : ""} noShrink ${
                !error ? "appendTop20" : "appendTop5"
              } appendLeft20`}
            >
              <span
                className={`${
                  rotate ? "btnLoader" : "font12 latoBlack capText"
                }`}
              >
                {SUBMIT}
              </span>
            </button>
          </div>
        </div>
        <p className="hrtlSeperater"></p>
        <div
          className="makeFlex column spaceBetween"
          style={{ marginTop: "auto" }}
        >
          <a
            className="font16 lineHeight20 capText latoBold appendBottom20"
            onClick={goToForgotUsernamePage}
          >
            Forgot Username
          </a>
          <a
            className="font16 lineHeight20 capText latoBold"
            onClick={goToIRCTCRegistrationPage}
          >
            Create New Account
          </a>
        </div>
      </>
    </Modal>
  );
};

export default withRouter(VerifyIrctcUserName);
